import { mapValues } from 'lodash';
import replaceUserVars from '../../lib/replaceUserVars';

const replaceUserVarsInPortalProp = (prop, context) => {
  if (!prop.shouldReplaceUserVars || typeof prop.value !== 'string') return prop;

  return {
    ...prop,
    value: replaceUserVars(prop.value, context)
  };
};

const replaceUserVarsInPortals = (portals, context) =>
  portals.map(portal => ({
    ...portal,
    props: mapValues(
      portal.props,
      prop => replaceUserVarsInPortalProp(prop, context)
    )
  }));

export default replaceUserVarsInPortals;
